import PropTypes from 'prop-types';
import { headerItemPropTypes } from './components/HeaderItem/HeaderItemPropTypes';
const itemPropShape = PropTypes.shape(headerItemPropTypes);
export const headerItemsCollectionPropTypes = {
  items: PropTypes.arrayOf(itemPropShape),
  expandAndFocusSearchBar: PropTypes.func
};